import { render, staticRenderFns } from "./BackToAuthorizationsIndex.vue?vue&type=template&id=6bf071a0&scoped=true&"
var script = {}
import style0 from "./BackToAuthorizationsIndex.vue?vue&type=style&index=0&id=6bf071a0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf071a0",
  null
  
)

export default component.exports